import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

export const analyticsStyles = {
    rankingHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '26px',
        gap: '13px',
        flexWrap: 'wrap',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            alignItems: 'flex-start',
        },
        [`@media (max-width: ${breakpoints.values.sm}px)`]: {
            marginBottom: '24px',
        },
        '&.ranking-header--inline': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '16px',
            [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '0px',
            },
            '& .ranking-header__filters': {
                width: '50%',
                minWidth: '50%',
                marginTop: '5px',
                [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                    width: '100%',
                    minWidth: '100%',
                },
            },
        },
        '& .ranking-header__filters': {
            width: '100%',
            minWidth: '100%',
            display: 'flex',
            flexDirection: 'row',
            gap: '12px',
            margin: '8px 0 6px',
            position: 'relative',
            [`@media (max-width: ${breakpoints.values.xl}px)`]: {
                margin: '-4px 0 5px',
                flexDirection: 'column',
                gap: '4px',
            },
            [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                margin: '-4px 0 18px',
            },
            '& > .MuiFormControl-root, & > .MuiAutocomplete-root, & > .autocomplete-parent': {
                minWidth: 'calc(50% - 6px)',
                [`@media (max-width: ${breakpoints.values.xl}px)`]: {
                    minWidth: '100%',
                },
                '& .MuiAutocomplete-root': {
                    minWidth: '100%',
                    '& .MuiFormControl-root': {
                        marginTop: '8px',
                    },
                    '& +.MuiAutocomplete-popper[data-popper-placement="bottom"]': {
                        top: '54px !important',
                    },
                },
            },
            '& .MuiFormHelperText-root': {
                display: 'none',
            },
        },
    },
    element: {
        '&.element--product': {
            '&:first-of-type': {
                marginTop: '36px',
                '& .element-header': {
                    paddingTop: '0',
                },
            },
            '& .progress-container': {
                marginLeft: '56px',
                maxWidth: 'calc(100% - 56px)',
                [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                    marginLeft: '0',
                    maxWidth: '100%',
                },
            },
            '& .element-header': {
                padding: '24px 0',
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    padding: '24px 0 12px',
                },
                '& + .MuiBox-root': {
                    marginTop: '0',
                },
            },
            '& + .element--product': {
                marginTop: '-3px',
            },
        },
        '&.element--tag': {
            marginBottom: '20px',
            '& .element-left': {
                flexDirection: 'column',
                alignItems: 'flex-start',
            },
            '& .element-right': {
                marginTop: '-3px',
                '& + .MuiTypography-root': {
                    marginTop: '-2px',
                },
            },
            '& .progress-container': {
                [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                    marginTop: '-5px',
                },
            },
        },
        '&.element--service-requests': {
            '& .element-header': {
                gap: '20px',
                [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                    gap: '8px',
                },
            },
        },
        '&.element--time-of-day': {
            '& .element-header': {
                '& + .MuiBox-root': {
                    marginTop: '10px',
                },
            },
        },
        '& .element-header': {
            display: 'flex',
            gap: 37,
            alignItems: 'center',
            alignSelf: 'stretch',
            marginBottom: '-1px',
            [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                gap: '12px',
            },
        },
        '& .element-left': {
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            '& .element-category': {
                display: 'block',
                margin: '-2px 0 2px 0',
                fontSize: '11px',
            },
            '& .element-image': {
                width: 44,
                height: 44,
                minWidth: 44,
                overflow: 'hidden',
                textAlign: 'center',
                margin: '0 12px 0 0',
                fontSize: '10px',
                [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                    display: 'none',
                },
                '& img': {
                    width: 'auto',
                    height: '100%',
                    objectFit: 'contain',
                    margin: '0 auto',
                },
                '& svg': {
                    width: '20px',
                    height: '20px',
                },
                '& + a': {
                    height: '40px',
                    display: 'flex',
                    maxWidth: '100%',
                    alignItems: 'center',
                    '& .MuiTypography-root': {
                        lineHeight: '20px',
                        letterSpacing: '-0.14px',
                        display: '-webkit-box',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'normal',
                        maxWidth: '100%',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                    },
                },
            },
        },
        '& .MuiTypography-caption': {
            fontSize: '14px',
        },
        '& .element-right': {
            display: 'flex',
            alignItems: 'center',
            '& .time-value': {
                fontSize: '14px',
                fontWeight: 600,
                lineHeight: '20px',
                letterSpacing: '-0.14px',
            },
            '& .MuiChip-root': {
                height: '20px',
                borderRadius: '4px',
                '& .MuiChip-label': {
                    fontSize: '11px',
                    fontWeight: 400,
                    lineHeight: '16px',
                    letterSpacing: '-0.11px',
                    padding: '2px 4px',
                },
            },
        },
        '& .percentage': {
            fontSize: '14px',
            fontWeight: 600,
            minWidth: '60px',
            textAlign: 'right',
        },
    },
    rankingFooter: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginTop: '29px',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            '& .MuiButtonBase-root.MuiButton-root': {
                width: '100%',
            },
        },
        '& .MuiButtonBase-root': {
            '&:hover, &:active, &:focus': {
                textTransform: 'none',
                textDecoration: 'none',
                color: 'inherit',
            },
        },
    },
    analyticsChartSubtitle: {
        padding: '11px 0',
        borderTop: `2px solid ${Palette.gray.gray75}`,
        borderBottom: `2px solid ${Palette.gray.gray75}`,
        letterSpacing: '-0.14px',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            padding: '6px 0',
        },
        '& p.MuiTypography-body1': {
            fontSize: '24px',
            lineHeight: '28px',
            letterSpacing: '-0.48px',
            marginBottom: '2px',
            fontFamily: 'Rubik',
            fontWeight: 400,
        },
    },
    periodInput: {
        '&.period-form': {
            border: `2px solid ${Palette.gray.gray200}`,
            '& .MuiFormControl-root.MuiFormControl-marginDense': {
                marginTop: '0px !important',
            },
        },
        '&.status-form': {
            border: 'none',
        },
        '&.period-form, &.status-form': {
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            borderRadius: '12px',
            '& .MuiFormControl-root': {
                margin: '0px',
                '& .MuiFormLabel-root': {
                    left: '-5px',
                },
                '& .MuiInputLabel-shrink': {
                    backgroundColor: Palette.gray.gray75,
                },
            },
            '& .MuiInputBase-root': {
                backgroundColor: 'transparent',
            },
            '& .MuiInputBase-root.MuiFilledInput-root': {
                '&::before': {
                    content: 'none',
                },
                '&::after': {
                    content: 'none',
                },
            },
            '& .MuiFormHelperText-root': {
                display: 'none',
            },
            '& .MuiSelect-select': {
                fontSize: '14px',
                padding: '7px 16px 7px 14px',
                borderRadius: '12px',
            },
            '& .MuiSelect-icon': {
                top: '50%',
                transform: 'translateY(-50%)',
                right: '14px',
            },
            '& .MuiSelect-select.MuiInputBase-input.MuiFilledInput-input:focus': {
                backgroundColor: Palette.gray.gray75,
            },
            '& .MuiInputBase-root.MuiFilledInput-root.Mui-focused': {
                borderRadius: '12px',
                boxShadow: `0 0 0 4px ${Palette.yellow.yellow400}`,
                outline: `2px solid ${Palette.black}`,
                backgroundColor: Palette.gray.gray75,
            },
            '& .period-select': {
                minWidth: '240px',
            },
            '& .period-date-input': {
                minWidth: '150px',
            },
            '& .custom-select-array-input': {
                '& .MuiFormControl-root': {
                    height: '44px',
                    justifyContent: 'center',
                    maxWidth: '100%',
                },
                '& .MuiFormLabel-root.top': {
                    backgroundColor: Palette.gray.gray75,
                },
                '& .chips-container': {
                    margin: '0 34px 0 14px',
                },
            },
        },
    },
    productTagRanking: {
        '&.product-tag-ranking': {
            padding: '32px',
            borderRadius: '16px',
            backgroundColor: Palette.white,
            margin: '0 !important',
            flex: '1',
            position: 'relative',
            color: `${Palette.black} !important`,
            textDecoration: 'none',
            minWidth: '280px',
            height: '124px',
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                padding: '12px',
                height: '100px',
            },
            '&:hover': {
                boxShadow: Palette.boxShadow.elevation3,
            },
            '& .MuiTypography-root.MuiTypography-caption': {
                position: 'absolute',
                top: '-7px',
                left: '30px',
                backgroundColor: Palette.white,
                borderRadius: '4px',
                padding: '2px 4px',
                lineHeight: '10px',
                textTransform: 'uppercase',
                fontSize: '9px',
                fontWeight: '700',
            },
            '& .tag-list-wrapper': {
                height: '82px',
                position: 'absolute',
                top: '32px',
                left: '32px',
                width: 'calc(100% - 64px)',
                overflowX: 'scroll',
                overflowY: 'hidden',
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    height: '75px',
                    top: '19px',
                    left: '12px',
                    width: 'calc(100% - 28px)',
                },
            },
            '& .tag-list': {
                display: 'flex',
                flexDirection: 'column',
                width: 'max-content',
                '& .tag-list-row': {
                    display: 'flex',
                    width: 'max-content',
                    gap: '4px',
                    flexWrap: 'nowrap',
                    '& + .tag-list-row': {
                        margin: '4px 0',
                    },
                },
                '& .item': {
                    borderRadius: '8px',
                    fontSize: '11px',
                    lineHeight: '16px',
                    fontWeight: '400',
                    color: Palette.black,
                    display: 'flex',
                    alignItems: 'center',
                    '& .name': {
                        padding: '6px 5px 6px 8px',
                    },
                    '& .percentage': {
                        position: 'relative',
                        fontWeight: '600',
                        padding: '6px 8px 6px 5px',
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '2px',
                            height: '100%',
                            backgroundColor: 'rgba(255, 255, 255, 0.4)',
                        },
                    },
                },
            },
        },
    },
    horizontalBars: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        '& .bars-wrapper': {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        '& .bar': {
            width: '18px',
            height: '3px',
            borderRadius: '2px',
        },
        '& .text-wrapper': {
            paddingTop: '2px',
            maxWidth: 'min-content',
        },
        '& .text-value': {
            fontSize: '11px',
            lineHeight: '16px',
            fontWeight: 400,
            whiteSpace: 'nowrap',
            letterSpacing: '-0.11px',
            maxWidth: 'min-content',
        },
        '& .text-number': {
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 600,
            whiteSpace: 'nowrap',
            maxWidth: 'min-content',
        },
    },
};
